// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__21PZ-","title":"InfoRow_title__1csDR"};